import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { color, border, font, mediaQuery } = baseVariables;

export const StyledPickupStatsAlerts = styled.div`
  .msnackbar-bottom-center {
    bottom: 5%;

    .icon-clear {
      margin-bottom: ${toRem(4)};
    }
  }

  .back-cta {
    color: ${color.base10};
    &:hover {
      text-decoration: underline;
    }
  }

  .property-name {
    margin-bottom: ${toRem(48)};
  }

  && .shell {
    border: none;
    background-color: transparent;
    box-shadow: none;
  }

  && .event-bookings {
    border-top: none;
    padding-top: ${toRem(8)};
  }

  && thead tr th,
  && tbody tr td {
    &:first-child {
      padding-left: 0;
    }
  }

  && thead tr th {
    color: ${color.neutral40};
    font-size: ${toRem(12)};
  }

  .email-notification-section {
    margin-top: ${toRem(32)};
    margin-bottom: ${toRem(32)};
    padding: ${toRem(24)};
    border: ${toRem(1)} ${border.borderStyleDefault} ${color.neutral20};
    border-radius: ${toRem(8)};
    background-color: ${color.base20};

    .section-divider {
      border-top: ${toRem(1)} ${border.borderStyleDefault} ${color.neutral20};
      margin: ${toRem(24)} ${toRem(-24)};
    }

    .add-recipients {
      margin-bottom: ${toRem(24)};

      .add-recipients-heading {
        font-size: ${toRem(16)};
        font-weight: ${font.fontWeightMedium};
        margin-bottom: ${toRem(4)};
      }

      .add-recipients-helper {
        font-size: ${toRem(14)};
        color: ${color.neutral40};
        margin-bottom: ${toRem(16)};
      }

      .add-email-row {
        display: flex;
        align-items: center;

        @media ${mediaQuery.lg} {
          gap: ${toRem(60)};
        }

        .email-input-wrapper {
          flex: 0 0 80%;
          max-width: 80%;
        }

        .add-email-btn {
          white-space: nowrap;
          margin-left: auto;
        }
      }
    }

    .recipients-table-section {
      padding-top: ${toRem(24)};

      .recipients-table {
        width: 100%;

        .recipients-table-heading-row,
        .recipients-table-subheader,
        .recipients-table-row {
          display: grid;
          grid-template-columns:
            minmax(0, 2fr)
            minmax(0, 1.5fr)
            minmax(0, 2fr);
          column-gap: ${toRem(32)};
          align-items: center;
          padding: ${toRem(12)} 0;
        }

        .recipients-table-heading-row {
          font-size: ${toRem(16)};
          color: ${color.base10};
          font-weight: ${font.fontWeightMedium};

          .col-frequency,
          .col-milestone {
            text-align: center;
          }
        }

        .recipients-table-subheader {
          font-size: ${toRem(12)};
          font-weight: ${font.fontWeightRegular};
          padding: ${toRem(6)} 0;
          border-top: ${toRem(1)} ${border.borderStyleDefault} ${color.neutral20};
          border-bottom: ${toRem(1)} ${border.borderStyleDefault} ${color.neutral20};

          .col-recipient {
            color: ${color.neutral40};

            @media ${mediaQuery.lg} {
              white-space: nowrap;
            }
          }

          .col-frequency,
          .col-milestone {
            display: flex;
            gap: 0;
            justify-content: center;
            color: ${color.base10};
            padding-right: ${toRem(12)};

            span {
              width: ${toRem(72)};
              text-align: center;
            }
          }
        }

        .recipients-table-row {
          font-size: ${toRem(14)};
          padding: ${toRem(20)} ${toRem(4)};
          border-bottom: ${toRem(1)} ${border.borderStyleDefault} ${color.neutral20};

          &.recipients-table-row-error {
            border: ${toRem(2)} ${border.borderStyleDefault} ${color.alert50};
            margin-top: ${toRem(10)};
            margin-bottom: ${toRem(10)};
            padding-top: ${toRem(14)};
            padding-bottom: ${toRem(20)};
          }

          &:last-child {
            border-bottom: none;

            &.recipients-table-row-error {
              border-bottom: ${toRem(2)} ${border.borderStyleDefault} ${color.alert50};
            }
          }
          .col-recipient {
            display: flex;
            justify-content: space-between;
            cursor: pointer;

            .actions {
              opacity: 0;
              transition: opacity 0.2s ease-in-out;
              button {
                background: none;
              }
            }
            .edit-mode {
              width: 100%;
              .email-edit-input {
                width: 90%;

                &:focus-within {
                  outline: -webkit-focus-ring-color auto ${toRem(1)};
                }
              }
              .tick-link {
                &:focus-within {
                  outline: -webkit-focus-ring-color auto ${toRem(1)};
                }
              }
            }
            .edit-link {
              &:focus-within {
                outline: -webkit-focus-ring-color auto ${toRem(1)};
              }
            }

            &:focus-within {
              background-color: ${color.neutral20};

              .actions {
                opacity: 1;
              }
            }
          }

          &:hover {
            .col-recipient {
              background-color: ${color.neutral20};
            }
            .actions {
              opacity: 1;
            }
          }
          .col-milestone {
            position: relative;
            padding-left: ${toRem(2)};

            &::before {
              content: '';
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-40%);
              height: ${toRem(36)};
              border-left: ${toRem(1)} ${border.borderStyleDefault} ${color.neutral20};
            }
          }
        }

        .col-frequency,
        .col-milestone {
          .checkbox-group {
            display: flex;
            gap: 0;
            justify-content: center;
            padding-bottom: ${toRem(8)};
          }

          .checkbox-item {
            display: flex;
            align-items: center;
            justify-content: center;
            width: ${toRem(72)};

            input[type='checkbox'] {
              margin: 0;
            }
          }
        }
      }
    }

    .alerts-footer {
      display: flex;
      justify-content: flex-end;
      gap: ${toRem(16)};
      padding-top: ${toRem(24)};
    }
  }
`;
